/**
 * API base URL helper for browser fetch() calls.
 *
 * We default to local backend for developer convenience, but in production
 * `REACT_APP_API_BASE_URL` should be set (and baked into the build).
 *
 * Expected format: `https://<backend-host>/api/v1`
 */
export const API_V1_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1')
  .replace(/\/+$/, '');

/**
 * Build an absolute URL for our backend API v1.
 *
 * Accepts either:
 * - `/api/v1/...` (will be normalized to avoid double-prefix), or
 * - `/...` (appended under the configured v1 base)
 */
export function apiV1Url(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const withoutV1Prefix = normalized.replace(/^\/api\/v1(?=\/|$)/, '');
  return `${API_V1_BASE_URL}${withoutV1Prefix}`;
}
